import { stringify } from "qs";
import fetchClient from "api/client";
import getPerPageQueryParam from "helpers/getPerPageQueryParam";

/**
 * @description GET api/categories/list
 * */

export default function getCategoriesList({
  queryKey: [, { page, perPage, ...queryParams }],
  signal,
}) {
  const queryString = stringify(
    {
      ...queryParams,
      page: page || 0,
      ...getPerPageQueryParam(perPage),
    },
    { addQueryPrefix: true },
  );

  return fetchClient.get(`categories/list${queryString}`, { signal });
}
